import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import TopBarButton from './TopBarButton';
import style from './TopBarItem.style';

function TopBarItem({
  subMenuItems, title, cy, icon, onClick, active,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let topBarButtonHandler = handleMenu;
  if (_.isEmpty(subMenuItems)) {
    topBarButtonHandler = onClick;
  }

  let activeStyles = {};

  if (active.find((navlink) => `/${navlink}` === location.pathname)) {
    activeStyles = style.active;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <TopBarButton
        title={title}
        icon={icon}
        cy={cy}
        onClick={topBarButtonHandler}
        sx={activeStyles}
      />
      {!_.isEmpty(subMenuItems) && (
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {Object.values(subMenuItems).map((item) => {
            return (
              <MenuItem
                key={item}
                style={style.menuItem}
                data-cy={item.cy}
                onClick={() => item.onClick()}
              >
                <Typography>{item.title}</Typography>
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </Box>
  );
}

export default TopBarItem;
